import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT } from '../fragments'

export const APPLY_DRIVER_TIP_VARIANT = gql`
  mutation ApplyDriverTipVariant($amount: Float!) {
    applyDriverTipVariant(input: { amount: $amount }) {
      cart {
        ...ShopCart
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
`
